module.exports = {
  API_SERVER_URL: 'https://tomcom-api.thomas-s.co.uk',
  GA_ID: 'GTM-KFGTTLC',
  STRIPE_PUB_KEY: 'pk_live_51JVYAiE5ZIqXfzmigmNHvbAV5VO3QUIPTlO2au1S0fwLWGfXh2BMd8zLP8a5btNpSfa4CJcuqLvtkxLrapc2rXs700NqO7EMbb',
  // Custom URL scheme the mobile app registers (iOS CFBundleURLSchemes /
  // Android android:scheme) — it is the bundle id, not 'tomcom'.
  APP_SCHEME: 'com.jbi.tomcom',
  PHOTO_COST: 20,
};
